import { Arrayify } from "./utils"


const formatter = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    maximumFractionDigits: 0,
})

export const Money = (iv) => {
    let m = formatter.format(iv.Value)
    if (iv.Type !== "Never") {
        m += "(inf)"
    }
    return m
}
export const SavingRuleText = (to, from, fromOtherL, remain, registered) => {

    let twho = ""
    let fwho = ""
    let move = "Transfer"
    let name = ""
    let amt = ""
    let min = ""
    let max = ""
    let toMax = ""
    let fromMin = ""
    let keepSpousal = ""
    let toAcct = ""
    let of = false
    let from2 = false
    let fromAcct = "your " + from
    let fromOther = ""

    console.log(fromOtherL)
    let added = 0
    for (let fk in fromOtherL) {
        let f = fromOtherL[fk]
        if (!(f.AccountName === "" && f.AccountType === "")) {
            added += 1
            let fn = ""
            if (fromOther !== "") {
                fromOther += " & "
            }
            if (f.AccountName !== "") {
                fn = f.AccountName
            } else {
                fn = f.AccountType
            }

            if (f.Who.length === 1) {
                if (f.Who[0] === "Personal") {
                    fwho = ""
                } else if (f.Who[0] === "Spousal") {
                    fwho = "spousal "
                }
            } else if (f.Who.length === 2) {
                fwho = "personal/spousal "
            }

            fromOther += fwho + fn
            fromAcct += " & " + fwho + fn
        }
    }
    // fromAcct += " account"
    // fromOther += " account"
    // if (added > 0) {
    //     fromAcct += "s"
    //     fromOther += "s"
    // }

    //console.log(to)
    if (to.Account.Who.length === 1) {
        if (to.Account.Who[0] === "Personal") {
            twho = "your"
        } else if (to.Account.Who[0] === "Spousal") {
            twho = "your Spousal"
        }
    } else if (to.Account.Who.length === 2) {
        twho = "your Personal/Spousal"
    }

    if (to.Account.AccountName !== "") {
        name = to.Account.AccountName
        toAcct = name
        if (Arrayify(registered).includes(name)) { // registered
            move = "Contribute"
        }
        name += " account"
    } else if (to.Account.AccountType !== "") {
        name = to.Account.AccountType
        if (name === "TFSA" || name === "TFFHSA" || name === "RRSP" || name === "DCPP" || name === "LIRA" || name === "RESP") {
            move = "Contribute"
        }
        name += " accounts"
        toAcct = name + " account(s)"
    }
    if (to.Method === "ReduceIncomeTo") {
        amt = "" + to.Percent + "%"
        of = true
    } else if (to.Method === "FlatValue") {
        amt = Money(to.Value)
        of = true
    } else if (to.Method === "PercentOfLimit") {
        amt = "up to " + to.Percent + "% of your total contribution room"
        from2 = true
    } else if (to.Method === "PercentOfYearlyLimit") {
        amt = "up to " + to.Percent + "% of your yearly contribution room"
        from2 = true
    } else if (to.Method === "PercentOfEmployment") {
        amt = "up to " + to.Percent + "% of " + to.EmploymentAccount + " wages"
        from2 = true
    } else if (to.Method === "PercentOfAvailable") {
        amt = "up to " + to.Percent + "%"
        of = true
    }

    if (to.Min.Value !== 0) {
        min = ", no less than " + Money(to.Min)
    }
    if (to.Max.Value !== 0) {
        max = ", no more than " + Money(to.Max)
    }
    if (to.ToMax.Value !== 0) {
        toMax = ", limiting " + toAcct + " to " + Money(to.ToMax)
    }
    if (to.FromMin.Value !== 0) {
        fromMin = ", keeping at least " + Money(to.FromMin) + " in " + fromOther
    }
    if (to.SpousalKeepBalanced) {
        keepSpousal = ", keeping personal & spousal " + toAcct + " balanced"
    }

    let remaining = ""
    if (remain) {
        remaining = "the remaining "
    }
    let from2se = ""
    if (from2) {
        from2se = ", from " + remaining + fromAcct
    }
    let ofs = ""
    if (of) {
        ofs = " of " + remaining + fromAcct
    }

    let text = move + " " + amt + " " + ofs + " to " + twho + " " + name + from2se + min + max + toMax + fromMin + keepSpousal
    return text

}
